export default "__VITE_ASSET__c67a6484__"